import { ReactNode, useEffect, useRef, useState } from 'react';
import { SideMenuBottomCard, SideMenuContainer, SideMenuList, SideMenuTopCard } from './style';

interface SideMenuProps {
    collapsed?: boolean;
    topCard?: ReactNode;
    list?: ReactNode;
    bottomCard?: ReactNode;
}

export const SideMenu = ({ collapsed = false, topCard, list, bottomCard }: SideMenuProps) => {
    const [hasScrollBar, setHasScrollBar] = useState<boolean>(false);
    const listRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const element = listRef?.current;

        if (!element) return;

        const setScrollBarState = () => setHasScrollBar(element.clientHeight < element.scrollHeight);

        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(() => {
                setScrollBarState();
            });

            observer.observe(element);
        } else {
            setScrollBarState();
        }
    }, []);
    return (
        <SideMenuContainer collapsed={collapsed} id="sideMenuContainer">
            {topCard ? <SideMenuTopCard>{topCard}</SideMenuTopCard> : null}
            {list ? (
                <SideMenuList ref={listRef} hasScrollBar={hasScrollBar} collapsed={collapsed}>
                    {list}
                </SideMenuList>
            ) : null}
            {bottomCard ? <SideMenuBottomCard hasScrollBar={hasScrollBar}>{bottomCard}</SideMenuBottomCard> : null}
        </SideMenuContainer>
    );
};
